import { v4 as uuid } from 'uuid';
import { getRequest } from './network';
import { notification, Progress } from 'antd';
import endpoints from '../constants/endPoints.json';
import axios from 'axios';

const uploadFile = async (file) => {
    const fileSuffix = uuid();
    const fixedFilename = file.name.replace(/\s+/g, '_');
    const filename = `${fileSuffix}_${fixedFilename}`;
    const key = `images/${filename}`
    const { data } = await getRequest({ key, fileType: file.type }, undefined, undefined, endpoints.common.presignedUrl)
    const { uploadURL, publicURL } = data
    
    // Track progress
    await axios.put(uploadURL, file, {
        headers: { 'Content-Type': file.type },
        onUploadProgress: (progressEvent) => {
            const { loaded } = progressEvent;
            const uploadedBytes = loaded;

            const progressPercent = Math.floor((uploadedBytes / file.size) * 100);
            if (progressPercent === 100) {
                notification.success({
                    key: `uploadProgress_${filename}`,
                    message: `Finished Uploading ${filename}`,
                    description: <Progress percent={progressPercent} status="active" />,
                    style: { marginTop: "15vh" },
                });
            } else {
                notification.open({
                    key: `uploadProgress_${filename}`,
                    message: `Uploading ${filename}`,
                    description: <Progress percent={progressPercent} status="active" />,
                    duration: 0,
                    style: { marginTop: "15vh" },
                });
            }
        },
    });

    return publicURL
}

export { uploadFile }
